/**
 * Domain-based storage layer.
 *
 * Feature code reads/writes browser storage through these per-domain modules
 * instead of naming keys or serializing by hand:
 *
 *   storageStore.calendar.setSelectedColleagues(ids);
 *   const ids = storageStore.calendar.getSelectedColleagues();
 *
 * Each module delegates to the low-level `Storage` facades and reuses key strings
 * from `StorageKeys`, so keys and (de)serialization live in one place. Generic,
 * parametric plumbing (per-instance DataTables state, arrow-navigation /
 * shopping-cart entity mapping, the searchform handle) stays on the low-level API.
 *
 * Webpack-bundled code imports `@helpers/storage/store`; legacy <script> code uses
 * the `window.storageStore` global (see ../global.js).
 */
import applications from './applications';
import applicantView from './applicant_view';
import positions from './positions';
import requisitions from './requisitions';
import reEmployment from './re_employment';
import talentCommunity from './talent_community';
import calendar from './calendar';
import evaluation from './evaluation';
import candidates from './candidates';
import conversational from './conversational';
import tags from './tags';
import widgets from './widgets';
import scheduling from './scheduling';
import ui from './ui';

const storageStore = {
    applications,
    applicantView,
    positions,
    requisitions,
    reEmployment,
    talentCommunity,
    calendar,
    evaluation,
    candidates,
    conversational,
    tags,
    widgets,
    scheduling,
    ui,
};

export default storageStore;
export {
    applications,
    applicantView,
    positions,
    requisitions,
    reEmployment,
    talentCommunity,
    calendar,
    evaluation,
    candidates,
    conversational,
    tags,
    widgets,
    scheduling,
    ui,
};
